module.exports = __webpack_public_path__ + "static/media/trail.d8b4944e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ChevyJourney/trail.jpg
// module id = 1072
// module chunks = 0